import { render, staticRenderFns } from "./SelectCustomerView.vue?vue&type=template&id=5fd61491&scoped=true"
import script from "./SelectCustomerView.vue?vue&type=script&lang=js"
export * from "./SelectCustomerView.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomerView.vue?vue&type=style&index=0&id=5fd61491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd61491",
  null
  
)

export default component.exports